module.exports = __webpack_public_path__ + "img/img-tit-brand.fcea65a8.jpg";